import type { SVGProps } from "react";
const SvgUserRoundX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#CE2222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.333 14A5.334 5.334 0 0 1 9.25 9.333m2.084 2 3.334 3.334m0-3.334-3.334 3.334M10 5.333a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0"
    />
  </svg>
);
export default SvgUserRoundX;
